import alt from "../alt";
import indexBy from "lodash/keyBy";
import mergeWith from "lodash/mergeWith";
import uniqBy from "lodash/uniqBy";
import ItemBucketActions from "../actions/ItemBucketActions";
import ItemBucketFetcher from "../utils/ItemBucketFetcher";

class ItemBucketStore {
  constructor() {
    this.bindActions(ItemBucketActions);

    this.state = {
      itemBuckets: {},
      isFetchingAll: false,
      hasUpdatedItemBuckets: false
    };

    this.exportPublicMethods({
      getItemBucketById: this.getItemBucketById.bind(this)
    });
  }

  getItemBucketById(id) {
    return this.state.itemBuckets[id];
  }

  onFetchAll(opts) {
    this.setState({
      isFetchingAll: true
    });

    ItemBucketFetcher.fetchAll({ ids: opts ? opts.ids : undefined }).then(
      item_buckets => {
        this.setState({
          isFetchingAll: false
        });
        ItemBucketActions.updateItemBuckets(indexBy(item_buckets, "id"));
      }
    );
  }

  onUpdateItemBuckets(itemBuckets) {
    function customizer(objValue, srcValue) {
      // Ensure we don't duplicate unique id'd objects - and preserve the
      // "newer" one when possible (by concatenating with the src first).
      if (Array.isArray(srcValue)) {
        return uniqBy(srcValue.concat(objValue || []), o =>
          o ? o.id || o : undefined
        );
      }
    }

    let updated = mergeWith(this.state.itemBuckets, itemBuckets, customizer);
    this.setState({ itemBuckets: updated, hasUpdatedItemBuckets: true });
  }
}

export default alt.createStore(ItemBucketStore, "ItemBucketStore");



// WEBPACK FOOTER //
// ./src/app/stores/ItemBucketStore.js